import {List, ListParams} from 'models/list';
import {AppraisalTemplate} from 'models/appraisalTemplate';
import {appraisalStatuses} from 'constants';

const state = {
  appraisalTemplates: new List(),
  appraisalTemplate: null
};

const getters = {
  appraisalTemplates: (state) => state.appraisalTemplates,
  appraisalTemplate: (state) => state.appraisalTemplate
};

const actions = {
  async getAppraisalTemplates({commit}, options) {
    commit('setLoading', true);
    const response = await this.$app.$http.get('/appraisal_templates', {params: new ListParams(options)});
    if (response.status === 200) {
      commit('setAppraisalTemplates', response.data);
      commit('setLoading', false);
    } else {
      commit('setLoading', false);
      this.$app.$snotify.error(this.$app.$t('messages.error.internalServerError'));
    }
    return response;
  },
  async getAppraisalTemplate({commit}, id) {
    commit('setLoading', true);
    const response = await this.$app.$http.get(`/appraisal_templates/${id}`);
    if (response.status === 200) {
      commit('setAppraisalTemplate', response.data);
      commit('setLoading', false);
    } else {
      commit('setAppraisalTemplate', null);
      commit('setLoading', false);
      this.$app.$snotify.error(this.$app.$t('messages.error.notFound',
        {entity: this.$app.$tc('models.appraisalTemplate.entity', 1)}));
    }
    return response;
  },
  async createAppraisalTemplate({commit}, data) {
    commit('setLoading', true);
    const response = await this.$app.$http.post('/appraisal_templates', data);
    commit('setLoading', false);
    if (this.$app.successCode(response.status)) {
      this.$app.$snotify.success(this.$app.$t('messages.success.created', {
        entity: this.$app.$tc('models.appraisalForm.entity', 1)
      }));
      this.$app.$router.push({name: 'AppraisalTemplates'});
    }
    return response;
  },
  async updateAppraisalTemplate({commit}, {id, data}) {
    commit('setLoading', true);
    const response = await this.$app.$http.put(`/appraisal_templates/${id}`, data);
    commit('setLoading', false);
    if (this.$app.successCode(response.status)) {
      this.$app.$snotify.success(this.$app.$t('messages.success.updated', {
        entity: this.$app.$tc('models.appraisalTemplate.entity', 1)
      }));
      this.$app.$router.push({name: 'AppraisalTemplates'});
    }
    return response;
  },
  async deleteAppraisalTemplate({commit}, id) {
    commit('setLoading', true);
    const response = await this.$app.$http.delete(`/appraisal_templates/${id}`);
    if (response.status === 200) {
      commit('setLoading', false);
      this.$app.$snotify.success(this.$app.$t('messages.success.deleted',
        {entity: this.$app.$tc('models.appraisalTemplate.entity', 1)}));
    } else {
      commit('setLoading', false);
      this.$app.$snotify.error(this.$app.$t('messages.error.deleted',
        {entity: this.$app.$tc('models.appraisalTemplate.entity', 1)}));
    }
    return response;
  },
  async publishAppraisalTemplate({commit}, id) {
    commit('setLoading', true);
    const response = await this.$app.$http.put(`/appraisal_templates/${id}/publish`);
    commit('setLoading', false);
    return response;
  },
  async duplicateAppraisalTemplate({commit}, id) {
    commit('setLoading', true);
    const response = await this.$app.$http.post(`/appraisal_templates/${id}/duplicate`);
    commit('setLoading', false);
    if (this.$app.successCode(response.status)) {
      this.$app.$snotify.success(this.$app.$t('messages.success.created', {
        entity: this.$app.$tc('models.appraisalTemplate.entity', 1)
      }));
    }
    return response;
  },
  async assignAppraisalTemplate({commit}, {appraisalTemplateId, employeeIds}) {
    commit('setLoading', true);
    const response = await this.$app.$http.post('/appraisals/assign', {
      appraisal_template_id: appraisalTemplateId,
      employee_ids: employeeIds
    });
    commit('setLoading', false);
    return response;
  },
  async getAssignedEmployeeIds(context, appraisalTemplateId) {
    const response = await this.$app.$http.get('/appraisals', {
      params: {
        appraisal_template_id: appraisalTemplateId,
        status: [
          appraisalStatuses.PENDING_EMPLOYEE, appraisalStatuses.PENDING_SUPERVISOR, appraisalStatuses.READY_FOR_MEETING
        ]
      }
    });
    if (response.status !== 200) {
      return [];
    }
    return response.data.items.map((appraisal) => `${appraisal.attributes.employee_id}`);
  }
};

const mutations = {
  setAppraisalTemplates: (state, data) => {
    state.appraisalTemplates = new List({
      items: data.items.map((template) => new AppraisalTemplate(template)),
      count: data.count
    });
  },
  setAppraisalTemplate: (state, data) => state.appraisalTemplate = data ? new AppraisalTemplate(data) : null
};

export default {
  state,
  getters,
  actions,
  mutations
};
